module.exports = __webpack_public_path__ + "static/img/7bg_8.c238e4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_8.png
// module id = 754
// module chunks = 1